<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Listing</title>
  <link rel="stylesheet" href="../css/style.css">
</head>

<div id="main-outer" class="main-outer">

  <header class="header" [ngStyle]="{'background-color': documentTypeResponseModel?.HeaderBGColor}">
    <div class="container">
      <a href="#" class="logo" *ngIf="!documentTypeResponseModel.LogoImage">Logo</a>
      <img *ngIf="documentTypeResponseModel.LogoImage" [(src)]="cardImageBase64" />
      <small>{{companyResponseModel?.CompanyName}}</small>
    </div>
  </header>

  <div class="alert" [ngClass]="messageClass ? 'success' : 'warning'" *ngIf="displayMessage">
    <p>{{message}}</p>
    <a class="close-popup" href="javascript:void(0);" (click)="closeMessagePopup()">
      <img width="20" src="assets/img/close-ic.svg">
    </a>
  </div>

  <div class="content-block" [ngClass]="filterResposniveEvent ? 'active-sidebar' : ''">
    <div class="content-block__filter">
      <a class="close-popup close-popup-filter" href="javascript:void(0);" (click)="filterClickEvent()"><img width="14"
          src="assets/img/close-ic.svg"> </a>

      <div *ngIf="documentTypeList?.length > 0 && !forSepcialCompanyDb && !isDocuware" style="padding-bottom: 32px;">
        <label class="form__label">Document Type</label>
        <p-dropdown appendTo="body" panelStyleClass="body-dropdown" [(ngModel)]="selectedDocumentType"
          [ngModelOptions]="{standalone: true}" class="select-dropdown" placeholder="Select"
          [options]="documentTypeList" (onChange)="onDocumentTypeChange()" [showClear]="true"
          optionLabel="DocumentTypeName"></p-dropdown>
      </div>

      <ng-container *ngIf="showSearchPanel">
        <form class="form" [formGroup]="form" autocomplete="off">
          <div class="form__scroll custom-webpage-left-filter">

            <!-- <h2>Search</h2> -->
            <!-- <ng-container *ngIf="searchInputList?.length > 0 && headers?.length > 2"> -->
            <ng-container *ngIf="searchInputList?.length > 0 && !forSepcialCompanyDb && isDocuware">
              <h2>Search</h2>
              <ng-container *ngFor="let sBox of searchInputList; let i = index; let last = last">
                <div class="form__group">
                  <label class="form__label">{{sBox.DisplayAs}}</label>
                  <input *ngIf="sBox.FieldType !== 'Date' && sBox.DisplayAs == 'Full Text'" type="text" value=""
                    class="form__control" formControlName="{{sBox?.FieldName}}" />

                  <p-dropdown appendTo="body" panelStyleClass="dropdown-panel" class="form__dropdown"
                    *ngIf="sBox.FieldType !== 'Date' && sBox.DisplayAs !== 'Full Text'" [options]="sBox.Values"
                    placeholder="Select" (onChange)="onSelectChange($event, sBox)" formControlName="{{sBox?.FieldName}}"
                    [filter]="true" [showClear]="true" [resetFilterOnHide]="true">
                  </p-dropdown>
                  <p-calendar [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" appendTo="body"
                    *ngIf="sBox.FieldType === 'Date'" class="form__calendar" formControlName="{{sBox?.FieldName}}"
                    [showIcon]="true" (onInput)="onSelectChange($event, sBox)"></p-calendar>
                </div>
                {{last ? callFunction(i) : ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="searchInputList?.length > 0 && !forSepcialCompanyDb && !isDocuware">
              <h2>Search</h2>
              <ng-container *ngFor="let sBox of searchInputList; let i = index; let last = last">
                <div class="form__group"
                  *ngIf="sBox.FieldName.toLowerCase() !== 'ispublic' && sBox.FieldType !== 'Integer' && sBox.FieldType !== 'Date' && sBox.FieldType !== 'Decimal'&& sBox.FieldType !== 'Currency'">
                  <label class="form__label">{{sBox.DisplayAs}}</label>
                  <input
                    *ngIf="sBox.FieldName.toLowerCase() !== 'ispublic' && sBox.FieldType !== 'Date' && sBox.DisplayAs == 'Full Text'"
                    type="text" value="" class="form__control" formControlName="{{sBox?.FieldName}}" />

                  <p-autoComplete class="form__autocomplete"
                    *ngIf="sBox.FieldType !== 'Date' && sBox.DisplayAs !== 'Full Text' && sBox.FieldType!=='List' && sBox.IsSearch"
                    formControlName="{{sBox?.FieldName}}" showEmptyMessage="true" [suggestions]="FilterValues"
                    (completeMethod)="filterAutoCompleteSuggestion($event, sBox)" field="label" [minLength]="2"
                    (onSelect)="onSelectChange($event, sBox)" (onClear)="onSelectChange($event,sBox)"
                    [forceSelection]="false" appendTo="body">
                  </p-autoComplete>


                  <p-dropdown class="select-dropdown" *ngIf="sBox.FieldType==='List'" field="label"
                    [formControl]="form.controls[sBox?.FieldName]" (onChange)="onDropdownChange($event, sBox)"
                    appendTo="body" [filter]="true" [options]="BindDropdown(sBox?.FieldName)" optionLabel="label"
                    optionValue="value">
                  </p-dropdown>
                </div>
                <div class="form__group"
                  *ngIf="sBox.FieldType === 'Integer' || sBox.FieldType === 'Date' || sBox.FieldType === 'Decimal' || sBox.FieldType === 'Currency'">

                  <label class="form__label">{{sBox.DisplayAs + ' From'}}</label>
                  <input type="text" *ngIf="sBox.FieldType !== 'Date'" value="" class="form__control"
                    formControlName="{{sBox?.FieldName + 'From'}}" />
                  <p-calendar [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" appendTo="body"
                    *ngIf="sBox.FieldType === 'Date'" class="form__calendar"
                    formControlName="{{sBox?.FieldName + 'From'}}" [showIcon]="true"></p-calendar>
                </div>
                <div class="form__group"
                  *ngIf="sBox.FieldType === 'Integer' || sBox.FieldType === 'Date' || sBox.FieldType === 'Decimal' || sBox.FieldType === 'Currency'">
                  <label class="form__label">{{sBox.DisplayAs + ' To'}}</label>
                  <input type="text" *ngIf="sBox.FieldType !== 'Date'" value="" class="form__control"
                    formControlName="{{sBox?.FieldName + 'To'}}" />
                  <p-calendar [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" appendTo="body"
                    *ngIf="sBox.FieldType === 'Date'" class="form__calendar"
                    formControlName="{{sBox?.FieldName + 'To'}}" [showIcon]="true"></p-calendar>

                </div>
                {{last ? callFunction(i) : ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="searchableFieldModel?.length > 0 && forSepcialCompanyDb">
              <h2>Search</h2>
              <ng-container *ngFor="let sBox of searchableFieldModel; let i = index; let last = last">
                <div class="form__group">
                  <label class="form__label">{{sBox.DisplayAs}}</label>
                  <input *ngIf="sBox.FieldType !== 'Date' && sBox.DisplayAs == 'Full Text'" type="text" value=""
                    class="form__control" formControlName="{{sBox?.FieldName}}" />

                  <!-- <p-autoComplete class="form__autocomplete" *ngIf="sBox.FieldType !== 'Date' && sBox.DisplayAs !== 'Full Text'" formControlName="{{sBox?.FieldName}}" showEmptyMessage="true"
             [suggestions]="sBox.SearchFieldValuesFiltered" (completeMethod)="filterAutoCompleteSuggestionForSpecialCompanies($event, sBox)" field="FieldValue" [minLength]="1" (onSelect)="onSelectChange($event, sBox)"
             (onClear)="onSelectChange($event, sBox)">
            </p-autoComplete> -->

                  <p-autoComplete class="form__autocomplete"
                    *ngIf="sBox.FieldType !== 'Date' && sBox.DisplayAs !== 'Full Text' && sBox.FieldType !== 'List'"
                    formControlName="{{sBox?.FieldName}}" showEmptyMessage="true"
                    [suggestions]="FilterValuesForSpecialCompanies"
                    (completeMethod)="filterAutoCompleteSuggestionForSpecialCompanies($event, sBox)" field="FieldValue"
                    [minLength]="1" (onSelect)="onSelectChange($event, sBox)" (onClear)="onSelectChange($event, sBox)"
                    [forceSelection]="true" appendTo="body">
                  </p-autoComplete>


                  <p-dropdown class="select-dropdown" *ngIf="sBox.FieldType==='List'" field="label"
                    [formControl]="form.controls[sBox?.FieldName]" (onChange)="onDropdownChange($event, sBox)"
                    appendTo="body" [filter]="true" [options]="BindDropdown(sBox?.FieldName)" optionLabel="label"
                    optionValue="value">
                  </p-dropdown>

                  <p-calendar [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange"
                    *ngIf="sBox.FieldType === 'Date'" class="form__calendar" formControlName="{{sBox?.FieldName}}"
                    [showIcon]="true" (onInput)="onSelectChange($event, sBox)"></p-calendar>
                </div>
                {{last ? callFunction(i) : ''}}
              </ng-container>
            </ng-container>
          </div>

          <div class="form__group btns" *ngIf="!searchLoader && !isDocuware">
            <button class="btn btn-primary" (click)="onLazyLoad($event)"
              [ngStyle]="{'background-color' : documentTypeResponseModel?.PageTitleColor}">Search</button>
            <a href="javascript:void(0);" *ngIf="displayClearButton" class="btn btn-secondary"
              (click)="resetFilter(true)">Clear</a>
          </div>

          <!-- <div class="form__group btns" *ngIf="!searchLoader && isDocuware">
            <button class="btn btn-primary" (click)="onSearch()" [ngStyle]="{'background-color' : documentTypeResponseModel?.PageTitleColor}">Search</button>
            <a href="javascript:void(0);" *ngIf="displayClearButton" class="btn btn-secondary" (click)="onReset()">Clear</a>
          </div> -->
        </form>
      </ng-container>
    </div>
    <div class="content-block__customer-content">
      <div class="responsive-filter">
        <a href="javascript:void(0);" class="mobile-block" (click)="filterClickEvent()">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
            <path fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2" d="M20 0H0l8 9.46V16l4 2V9.46z" transform="translate(1 1)" />
          </svg>
        </a>
        <h2 [ngStyle]="{'color' : documentTypeResponseModel?.PageTitleColor}">Documents </h2>

      </div>

      <h3 [ngStyle]="{'color' : documentTypeResponseModel?.DocumentGroupTitleColor}">
        {{customAuthResponseModel?.DocumentType?.DocumentTypeName}} : {{totalRecords ? totalRecords : 0}}
      </h3>

      <div class="document-list-outer">

        <div class="table-responsive" *ngIf="isDocuware">
          <table class="tables sortable custom-table" style="background-color: white;">
            <ng-container *ngIf="headers?.length > 2  && searchRecords?.length > 0">
              <thead [ngStyle]="{'background-color' : documentTypeResponseModel?.TableHeaderBGColor}">
                <tr>
                  <ng-container *ngFor="let header of headers">
                    <th width="100" class="text-center" *ngIf="header.headerName === 'View'"
                      [ngStyle]="{'color' : documentTypeResponseModel?.TableHeaderLabelColor, 'background-color' : documentTypeResponseModel?.TableHeaderBGColor}">
                      View
                    </th>

                    <ng-container *ngIf="header.headerName !== 'View'">
                      <th
                        [ngStyle]="{'color' : documentTypeResponseModel?.TableHeaderLabelColor, 'background-color' : documentTypeResponseModel?.TableHeaderBGColor}"
                        [(appSort)]="searchRecords" data-order="desc" [attr.data-name]="header.headerName" scope="col"
                        *ngIf="!(header.headerName === 'DocumentId')">
                        {{header.headerName}}
                      </th>
                    </ng-container>

                  </ng-container>
                </tr>
              </thead>
            </ng-container>
            <tbody>

              <ng-container *ngIf="searchRecords?.length > 0">
                <tr *ngFor="let record of searchRecords">
                  <td class="text-center">
                    <a class="link" (click)="onDownload(record)" href="javascript:void(0);">
                      <!-- <svg class="view-svg" xmlns="http://www.w3.org/2000/svg" width="512" height="512" enable-background="new 0 0 512 512" viewBox="0 0 512 512"><path d="M256,406c-30.6,0-62.2-7.6-94-22.5c-24.9-11.7-50-27.9-74.6-48.2C45.9,301,20.3,267,19.2,265.6
                            c-4.3-5.7-4.3-13.5,0-19.2c1.1-1.4,26.7-35.4,68.2-69.7c24.6-20.3,49.7-36.5,74.6-48.2c31.8-14.9,63.4-22.5,94-22.5
                            s62.2,7.6,94,22.5c24.9,11.7,50,27.9,74.6,48.2c41.5,34.3,67.2,68.3,68.2,69.7c4.3,5.7,4.3,13.5,0,19.2
                            c-1.1,1.4-26.7,35.4-68.2,69.7c-24.6,20.3-49.7,36.5-74.6,48.2C318.2,398.4,286.6,406,256,406z M52.6,256
                            c25.1,29.7,108,118,203.4,118c95.6,0,178.3-88.3,203.4-118c-25.1-29.7-108-118-203.4-118C160.4,138,77.7,226.3,52.6,256z"/><path d="M256,328c-39.7,0-72-32.3-72-72s32.3-72,72-72s72,32.3,72,72S295.7,328,256,328z M256,216
                            c-22.1,0-40,17.9-40,40s17.9,40,40,40s40-17.9,40-40S278.1,216,256,216z"/></svg> -->

                      <svg id="Capa_1" class="view-svg" enable-background="new 0 0 512 512" height="512"
                        viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                            d="m15 91c8.284 0 15-6.716 15-15v-46h46c8.284 0 15-6.716 15-15s-6.716-15-15-15h-61c-8.284 0-15 6.716-15 15v61c0 8.284 6.716 15 15 15z" />
                          <path
                            d="m15 512h61c8.284 0 15-6.716 15-15s-6.716-15-15-15h-46v-46c0-8.284-6.716-15-15-15s-15 6.716-15 15v61c0 8.284 6.716 15 15 15z" />
                          <path
                            d="m497 91c8.284 0 15-6.716 15-15v-61c0-8.284-6.716-15-15-15h-61c-8.284 0-15 6.716-15 15s6.716 15 15 15h46v46c0 8.284 6.716 15 15 15z" />
                          <path
                            d="m497 421c-8.284 0-15 6.716-15 15v46h-46c-8.284 0-15 6.716-15 15s6.716 15 15 15h61c8.284 0 15-6.716 15-15v-61c0-8.284-6.716-15-15-15z" />
                          <path
                            d="m256 361c57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105 47.103 105 105 105zm0-180c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75z" />
                          <path
                            d="m256 301c24.813 0 45-20.187 45-45s-20.187-45-45-45-45 20.187-45 45 20.187 45 45 45zm0-60c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15z" />
                          <path
                            d="m76.023 342.381c50.592 43.433 113.077 78.619 179.977 78.619 66.903 0 129.389-35.19 179.977-78.619 44.516-38.216 72.029-76.003 73.179-77.593 3.793-5.246 3.793-12.332 0-17.577-1.149-1.59-28.663-39.377-73.179-77.593-50.592-43.432-113.077-78.618-179.977-78.618-66.903 0-129.389 35.19-179.977 78.619-44.516 38.216-72.029 76.003-73.179 77.593-3.793 5.246-3.793 12.332 0 17.577 1.15 1.589 28.664 39.377 73.179 77.592zm179.977-221.381c63.673 0 122.116 38.583 159.933 70.951 29.612 25.345 51.609 51.001 62.093 64.044-10.341 12.847-31.897 37.957-61.025 63.071-41.709 35.962-98.941 71.934-161.001 71.934-63.673 0-122.116-38.583-159.933-70.951-29.614-25.347-51.612-51.004-62.093-64.044 10.341-12.847 31.898-37.956 61.026-63.071 41.708-35.962 98.94-71.934 161-71.934z" />
                        </g>
                      </svg>
                    </a>
                  </td>

                  <ng-container *ngFor="let header of headers">
                    <td
                      *ngIf="(header.fieldType !== 'Date') && (header.headerName !== 'DocumentId') && (header.headerName !== 'View')">
                      {{record[header.headerName]}}
                    </td>

                    <td
                      *ngIf="(header.fieldType == 'Date') && (header.headerName !== 'DocumentId') && (header.headerName !== 'View')">
                      {{record[header.headerName] | date: 'MM/dd/yyyy'}}
                    </td>

                  </ng-container>
                </tr>
              </ng-container>

              <ng-container *ngIf="searchRecords?.length === 0">
                <tr>
                  <td colspan="6" style="text-align: left !important;">No records found.</td>
                </tr>
              </ng-container>

            </tbody>
            <ng-container *ngIf=" !loading && !searchRecords && !isInitialEmptyState">
              No records found
            </ng-container>
            <ng-container *ngIf="!loading && !searchRecords && isInitialEmptyState">
              <!-- No records found. -->
              Please apply search to proceed.
            </ng-container>
          </table>
        </div>

        <ng-container *ngIf="!isDocuware && documentTypeResponseModel">
          <div class="table-responsive custom-web-page-table">
            <div class="tables table-new">
              <!-- <div class="column-frozen-table" [ngClass]="{'tables table': documentTypeResponseModel?.TableHeaderBGColor}"> -->
              <p-table *ngIf="tableVisible" #dataTable class="tables-frozen" [columns]="headers" [value]="searchRecords"
                [scrollable]="true" [virtualScroll]="true" [lazy]="isLazyLoadingEnabled"
                (onLazyLoad)="onLazyLoad($event)" [totalRecords]="totalRecords" [rows]="lazyPageSize"
                scrollHeight="400px" [sortField]="sortField" [sortOrder]="sortOrder">
                <ng-template pTemplate="header" let-columns>
                  <!-- <tr *ngIf="searchRecords?.length > 0"  > -->
                  <tr [ngStyle]="{'background-color' : documentTypeResponseModel?.TableHeaderBGColor}"
                    *ngIf="searchRecords?.length > 0">
                    <ng-container *ngFor="let header of headers">
                      <th style="max-width: 80px;" width="80" *ngIf="header.headerName === 'View'"
                        [ngStyle]="{'color' : documentTypeResponseModel?.TableHeaderLabelColor, 'background-color' : documentTypeResponseModel?.TableHeaderBGColor}">
                        View
                      </th>

                      <ng-container *ngIf="header.headerName !== 'View'">
                        <th width="180" style="min-width: 180px;"
                          *ngIf="!(header.headerName === 'DocumentId') && (header.headerName.toLowerCase() !== 'ispublic')"
                          [pSortableColumn]="header.headerName"
                          [ngStyle]="{'color' : documentTypeResponseModel?.TableHeaderLabelColor, 'background-color' : documentTypeResponseModel?.TableHeaderBGColor}">
                          {{header.headerName}}
                        </th>
                      </ng-container>

                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-record let-columns="headers">
                  <!-- <tr *ngIf="searchRecords?.length > 0 && !record.DynamicFields['isPublic']"> -->
                  <tr *ngIf="searchRecords?.length > 0">
                    <td width="80">

                        <a style="text-align: center;" class="link" *ngIf="(isView && isCustomer) || (!isCustomer)" (click)="onView(record['DocumentTypeInboxId'])" href="javascript:void(0);">
                          <!-- <a class="link" (click)="onView(record['DocumentTypeDocumentId'])"
                          href="javascript:void(0);"> -->
                          <svg id="Capa_1" class="view-svg" enable-background="new 0 0 512 512" height="512"
                            viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg">
                            <g>
                              <path
                                d="m15 91c8.284 0 15-6.716 15-15v-46h46c8.284 0 15-6.716 15-15s-6.716-15-15-15h-61c-8.284 0-15 6.716-15 15v61c0 8.284 6.716 15 15 15z" />
                              <path
                                d="m15 512h61c8.284 0 15-6.716 15-15s-6.716-15-15-15h-46v-46c0-8.284-6.716-15-15-15s-15 6.716-15 15v61c0 8.284 6.716 15 15 15z" />
                              <path
                                d="m497 91c8.284 0 15-6.716 15-15v-61c0-8.284-6.716-15-15-15h-61c-8.284 0-15 6.716-15 15s6.716 15 15 15h46v46c0 8.284 6.716 15 15 15z" />
                              <path
                                d="m497 421c-8.284 0-15 6.716-15 15v46h-46c-8.284 0-15 6.716-15 15s6.716 15 15 15h61c8.284 0 15-6.716 15-15v-61c0-8.284-6.716-15-15-15z" />
                              <path
                                d="m256 361c57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105 47.103 105 105 105zm0-180c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75z" />
                              <path
                                d="m256 301c24.813 0 45-20.187 45-45s-20.187-45-45-45-45 20.187-45 45 20.187 45 45 45zm0-60c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15z" />
                              <path
                                d="m76.023 342.381c50.592 43.433 113.077 78.619 179.977 78.619 66.903 0 129.389-35.19 179.977-78.619 44.516-38.216 72.029-76.003 73.179-77.593 3.793-5.246 3.793-12.332 0-17.577-1.149-1.59-28.663-39.377-73.179-77.593-50.592-43.432-113.077-78.618-179.977-78.618-66.903 0-129.389 35.19-179.977 78.619-44.516 38.216-72.029 76.003-73.179 77.593-3.793 5.246-3.793 12.332 0 17.577 1.15 1.589 28.664 39.377 73.179 77.592zm179.977-221.381c63.673 0 122.116 38.583 159.933 70.951 29.612 25.345 51.609 51.001 62.093 64.044-10.341 12.847-31.897 37.957-61.025 63.071-41.709 35.962-98.941 71.934-161.001 71.934-63.673 0-122.116-38.583-159.933-70.951-29.614-25.347-51.612-51.004-62.093-64.044 10.341-12.847 31.898-37.956 61.026-63.071 41.708-35.962 98.94-71.934 161-71.934z" />
                            </g>
                          </svg>

                        </a>
                     
                    </td>

                    <ng-container *ngFor="let header of headers">
                      <td width="180" style="min-width: 180px;"
                        *ngIf="header.headerName.toLowerCase()!== 'ispublic' && (header.fieldType !== 'Date') && (header.headerName !== 'DocumentId') && (header.headerName !== 'View') && (header.fieldType !== 'Currency')">
                        {{record.DynamicFields[header.headerName]}}</td>
                      <td width="180" style="min-width: 180px;"
                        *ngIf="header.headerName.toLowerCase()!== 'ispublic' && (header.fieldType === 'Currency') && !record.DynamicFields[header.headerName]">
                      </td>
                      <td width="180" style="min-width: 180px;"
                        *ngIf="header.headerName.toLowerCase()!== 'ispublic' && (header.fieldType === 'Currency') && record.DynamicFields[header.headerName]">
                        $ {{record.DynamicFields[header.headerName]}}</td>
                      <td width="180" style="min-width: 180px;"
                        *ngIf="(header.fieldType == 'Date') && (header.headerName !== 'DocumentId') && (header.headerName !== 'View') && header.headerName.toLowerCase()!== 'ispublic'">
                        {{record.DynamicFields[header.headerName] | date: 'MM/dd/yyyy'}}</td>
                    </ng-container>
                  </tr>
                </ng-template>
                <!-- <ng-template pTemplate="emptymessage" let-documentCabinet> -->
                <ng-template pTemplate="emptymessage" let-record *ngIf="!loading && !isInitialEmptyState">
                  <tr>
                    <td [attr.colspan]="headers?.length">
                      No records found
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-record *ngIf="isInitialEmptyState">
                  <tr *ngIf="!loading">
                    <td [attr.colspan]="headers?.length">
                      No records found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </ng-container>

        <!-- <div class="table-paginetion" *ngIf="!searchLoader && isDocuware"> -->
        <div class="table-paginetion" *ngIf="!searchLoader && displayPagination && isDocuware">
          <div class="total-record" *ngIf="totalRecordCount"> {{startRecord}} - {{endRecord}} of
            <strong>{{totalRecordCount}}</strong>
          </div>
          <div class="content_detail__pagination cdp" actpage="1">
            <a href="javascript:void(0)" class="cdp_i" (click)="changePage('-1')">prev</a>
            <ng-container *ngFor="let pageNo of pageArray; let i = index">
              <a href="javascript:void(0)" class="cdp_i" (click)="changePage(i+1)"><span>{{i+1}}</span></a>
            </ng-container>
            <a href="javascript:void(0)" class="cdp_i" (click)="changePage('+1')">next</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loader-outer" *ngIf="loading || customLoader">
    <div class="loader"></div>
  </div>

</div>


<p-dialog [(visible)]="DocumentViewerPopup" [modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
  [ngClass]="{'full-view-mode': isActive}" class="pdf-popup-outer">
  <div class="popop-content width-900 text-center h-100 document-preview-pop document-preview-pop-zoom-outer">
    <div class="document-viewer-box">
      <div class="loader-outer" *ngIf="viewerLoader">
        <div class="loader"></div>
      </div>
      <div class="pop-content mb-0">
        <div class="preview-header">
          <div class="title">
            <h3>Preview Document</h3>
          </div>
          <div class="pdf-controls">
            <div class="toolbar zoom-box">
              <button class="zoom-option" (click)="zoomIn()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="7" width="2" height="16" rx="1" fill="#4644AE" />
                  <rect y="9" width="2" height="16" rx="1" transform="rotate(-90 0 9)" fill="#4644AE" />
                </svg>

              </button>
              <span class="percentage">{{ currentZoom * 100 | number:'1.0-0' }}%</span>
              <button class="zoom-option" (click)="zoomOut()">
                <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="2" width="2" height="16" rx="1" transform="rotate(-90 0 2)" fill="#4644AE" />
                </svg>

              </button>
            </div>
            <button class="full-view-icon-open" (click)="toggleClass()"><svg width="101" height="101"
                viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.717 10.6667H30.667C31.9931 10.6667 33.2648 10.1399 34.2025 9.20222C35.1402 8.26454 35.667 6.99277 35.667 5.66669C35.667 4.3406 35.1402 3.06883 34.2025 2.13115C33.2648 1.19347 31.9931 0.666687 30.667 0.666687H10.667C8.01483 0.666687 5.47129 1.72025 3.59592 3.59562C1.72056 5.47098 0.666992 8.01452 0.666992 10.6667V30.6667C0.666992 31.9928 1.19378 33.2645 2.13146 34.2022C3.06914 35.1399 4.34091 35.6667 5.66699 35.6667C6.99308 35.6667 8.26485 35.1399 9.20253 34.2022C10.1402 33.2645 10.667 31.9928 10.667 30.6667V17.7167L32.117 39.2167C32.5818 39.6853 33.1348 40.0573 33.7441 40.3111C34.3534 40.565 35.0069 40.6957 35.667 40.6957C36.3271 40.6957 36.9806 40.565 37.5899 40.3111C38.1992 40.0573 38.7522 39.6853 39.217 39.2167C39.6856 38.7519 40.0576 38.1989 40.3115 37.5896C40.5653 36.9803 40.696 36.3267 40.696 35.6667C40.696 35.0066 40.5653 34.3531 40.3115 33.7438C40.0576 33.1345 39.6856 32.5815 39.217 32.1167L17.717 10.6667Z"
                  fill="#4644AE" />
                <path
                  d="M90.6667 0.666687H70.6667C69.3406 0.666687 68.0688 1.19347 67.1312 2.13115C66.1935 3.06883 65.6667 4.3406 65.6667 5.66669C65.6667 6.99277 66.1935 8.26454 67.1312 9.20222C68.0688 10.1399 69.3406 10.6667 70.6667 10.6667H83.6167L62.1167 32.1167C61.648 32.5815 61.2761 33.1345 61.0222 33.7438C60.7684 34.3531 60.6377 35.0066 60.6377 35.6667C60.6377 36.3267 60.7684 36.9803 61.0222 37.5896C61.2761 38.1989 61.648 38.7519 62.1167 39.2167C62.5815 39.6853 63.1345 40.0573 63.7438 40.3111C64.3531 40.565 65.0066 40.6957 65.6667 40.6957C66.3267 40.6957 66.9803 40.565 67.5896 40.3111C68.1989 40.0573 68.7519 39.6853 69.2167 39.2167L90.6667 17.7167V30.6667C90.6667 31.9928 91.1935 33.2645 92.1312 34.2022C93.0688 35.1399 94.3406 35.6667 95.6667 35.6667C96.9928 35.6667 98.2645 35.1399 99.2022 34.2022C100.14 33.2645 100.667 31.9928 100.667 30.6667V10.6667C100.667 8.01452 99.6131 5.47098 97.7378 3.59562C95.8624 1.72026 93.3189 0.666687 90.6667 0.666687Z"
                  fill="#4644AE" />
                <path
                  d="M32.117 62.1167L10.667 83.6167V70.6667C10.667 69.3406 10.1402 68.0688 9.20253 67.1312C8.26485 66.1935 6.99308 65.6667 5.66699 65.6667C4.34091 65.6667 3.06914 66.1935 2.13146 67.1312C1.19378 68.0688 0.666992 69.3406 0.666992 70.6667V90.6667C0.666992 93.3189 1.72056 95.8624 3.59592 97.7378C5.47129 99.6131 8.01483 100.667 10.667 100.667H30.667C31.9931 100.667 33.2648 100.14 34.2025 99.2022C35.1402 98.2646 35.667 96.9928 35.667 95.6667C35.667 94.3406 35.1402 93.0688 34.2025 92.1312C33.2648 91.1935 31.9931 90.6667 30.667 90.6667H17.717L39.217 69.2167C40.1585 68.2752 40.6875 66.9982 40.6875 65.6667C40.6875 64.3352 40.1585 63.0582 39.217 62.1167C38.2755 61.1752 36.9985 60.6462 35.667 60.6462C34.3355 60.6462 33.0585 61.1752 32.117 62.1167Z"
                  fill="#4644AE" />
                <path
                  d="M95.6669 65.6667C94.3409 65.6667 93.0691 66.1935 92.1314 67.1312C91.1937 68.0688 90.6669 69.3406 90.6669 70.6667V83.6167L69.2169 62.1167C68.2754 61.1752 66.9984 60.6462 65.6669 60.6462C64.3354 60.6462 63.0585 61.1752 62.1169 62.1167C61.1754 63.0582 60.6465 64.3352 60.6465 65.6667C60.6465 66.9982 61.1754 68.2752 62.1169 69.2167L83.6169 90.6667H70.6669C69.3409 90.6667 68.0691 91.1935 67.1314 92.1312C66.1937 93.0688 65.6669 94.3406 65.6669 95.6667C65.6669 96.9928 66.1937 98.2646 67.1314 99.2022C68.0691 100.14 69.3409 100.667 70.6669 100.667H90.6669C93.3191 100.667 95.8626 99.6131 97.738 97.7378C99.6134 95.8624 100.667 93.3189 100.667 90.6667V70.6667C100.667 69.3406 100.14 68.0688 99.2025 67.1312C98.2648 66.1935 96.993 65.6667 95.6669 65.6667Z"
                  fill="#4644AE" />
              </svg>
            </button>
            <button class="full-view-icon-close" (click)="toggleClass()"><svg width="101" height="101"
                viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.76004 2.75907C5.54955 -0.030366 10.0721 -0.030366 12.8616 2.75907L50.6681 40.5656L88.4746 2.75907C91.2638 -0.030366 95.7867 -0.030366 98.576 2.75907C101.365 5.54857 101.365 10.0712 98.576 12.8607L60.7695 50.6671L98.576 88.4736C101.365 91.2629 101.365 95.7857 98.576 98.575C95.7867 101.364 91.2638 101.364 88.4746 98.575L50.6681 60.7685L12.8616 98.575C10.0721 101.364 5.54955 101.364 2.76004 98.575C-0.0293894 95.7857 -0.0293894 91.2629 2.76004 88.4736L40.5666 50.6671L2.76004 12.8607C-0.0293894 10.0712 -0.0293894 5.54857 2.76004 2.75907Z"
                  fill="#4644AE" />
              </svg>
            </button>
          </div>
        </div>

        <div class="image-pdf-viewer-wrapper">
          <div class="image-pdf-viewer" [ngClass]="zoomClass">
            <ng-container
              *ngIf="filePath && fileExtension != 'pdf' && fileExtension != 'png' && fileExtension != 'jpg' && fileExtension != 'jpeg' && fileExtension != 'tiff' && fileExtension != 'dotx' 
              && fileExtension != 'doc' && fileExtension != 'docx' && fileExtension != 'xlsx' && fileExtension != 'pptx' && fileExtension != 'docm' && fileExtension != 'xlsm' && fileExtension != 'pptm' 
              && fileExtension != 'xls' && fileExtension != 'ppt' && fileExtension != 'json' && fileExtension != 'txt' && fileExtension != 'tif'">
              <p>Browser doesn't support file format</p>
              <button class="btn-primary mb-0 m-auto" style="margin: 0 auto;" type="button"
                (click)="onFileDownload(documentTypeDocumentId)">
                Download
              </button>
            </ng-container>



            <div id="print-section" style="width: 100%;">
              <!-- Nutrient SDK Viewer Container -->
              <div #nutrientViewer [style.display]="isNutrientViewer ? 'block' : 'none'"
                class="nutrient-viewer-container">
              </div>

              <!-- <img *ngIf="isImage && !isNutrientViewer" [src]="transformImg()"
                [style.transform]="'scale(' + currentZoom + ')'" style="transform-origin: top left;" /> -->

              <!-- <div *ngIf="!isNutrientViewer && !isPdf && !isImage && !isOfficeDoc && filePath"
                class="unsupported-format text-center p-4">
                <p>This file format is not supported for preview.</p>
                <button class="btn-primary" (click)="onFileDownload(documentTypeDocumentId)">
                  Download File
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="fileExtension === 'pdf' || fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'tiff' || fileExtension === 'docx' || fileExtension === 'xlsx' || fileExtension === 'pptx'">

    </ng-container>
    <div class="btns-box document-viewer-box-btn">
      <!-- <button class="btn-primary download-file" (click)="onFileDownload(documentTypeDocumentId)">
        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.7979 15.6562C11.8219 15.6861 11.8525 15.7103 11.8876 15.7269C11.9226 15.7435 11.961 15.7522 12 15.7522C12.039 15.7522 12.0774 15.7435 12.1124 15.7269C12.1474 15.7103 12.1781 15.6861 12.2021 15.6562L15.7957 11.2281C15.9273 11.0656 15.8086 10.825 15.5936 10.825H13.216V0.25C13.216 0.1125 13.1005 0 12.9594 0H11.0342C10.893 0 10.7775 0.1125 10.7775 0.25V10.8219H8.40642C8.19144 10.8219 8.07273 11.0625 8.20428 11.225L11.7979 15.6562ZM23.7433 14.5625H21.8182C21.677 14.5625 21.5615 14.675 21.5615 14.8125V19.625H2.4385V14.8125C2.4385 14.675 2.32299 14.5625 2.18182 14.5625H0.256684C0.115508 14.5625 0 14.675 0 14.8125V21C0 21.5531 0.458823 22 1.02674 22H22.9733C23.5412 22 24 21.5531 24 21V14.8125C24 14.675 23.8845 14.5625 23.7433 14.5625Z"
            fill="white" />
        </svg> Download
      </button> -->
      <!-- <button class="btn-primary" *ngIf="isImage" printSectionId="print-section" [printTitle]="fileName" ngxPrint>
        Print
      </button> -->
      <!-- <button class="btn-primary" *ngIf="!isImage" (click)="onPdfDownload(documentTypeDocumentId)">Print</button> -->
      <button class="btn-secondary ml-16 mb-0" type="button" (click)="onCloseDocumentViewer()">Cancel</button>
    </div>
  </div>
</p-dialog>



